<template>
<div>
    <form-wizard ref="formWizard" stepSize="xs" shape="circle" title="" subtitle="" color="#0064aa">
        <tab-content :title="$lang('參賽兒童及家庭成員')" :before-change="validateAsync1">
            <StepOne ref="step1" />
        </tab-content>
        <tab-content :title="$lang('TITLE_ADD_GAME_TEXT')" :before-change="validateAsync2" next-button-text="Go next!">
            <StepTwo ref="step2" />
        </tab-content>
        <tab-content :title="$lang('TITLE_APPROVAL_GAME_INFO')" :before-change="validateAsync3">
            <StepThird ref="step3" @errs='errdone()' />
        </tab-content>
        <tab-content :title="$lang('報名完成')">
            <StepFourth ref="step4" />
        </tab-content>
        <template slot="footer" slot-scope="props">
       <div class="row px-3 justify-content-md-between">
                <div class="">
                <wizard-button    v-if="props.activeTabIndex > 0 && !props.isLastStep" :disabled="props.activeTabIndex === 1 && readOnlyStatus != 0"  @click.native="props.prevTab()" :style="props.fillButtonStyle">
                    {{ $lang("TEXT_PREV") }}
                </wizard-button>
            </div>
            <div class="row px-3  justify-content-between" :class="props.activeTabIndex !== 1?'mt-md-0 mt-3':''">
                <wizard-button  v-if="!props.isLastStep" @click.native="props.nextTab()" class="mr-2"  :style="props.fillButtonStyle">
                  <b-spinner v-if="btnLoading" style="margin-right:10px" small label="Small Spinner"></b-spinner>   {{props.activeTabIndex == 2 ? $lang("提交") : $lang("TEXT_NEXT")}}
                </wizard-button>
                <wizard-button v-else @click.native="goUp" class=" finish-button" :style="props.fillButtonStyle">{{ $lang("TEXT_SUBMBIT") }}</wizard-button>
                <wizard-button v-if="props.activeTabIndex === 2" @click.native="back" class="" :style="props.fillButtonStyle">{{$lang("TITLE_RETURN_INDEX")}}</wizard-button>
            </div>
       </div>
        </template>
    </form-wizard>
</div>
</template>

<script>
import StepOne from "./StepOne";
import StepTwo from "./StepTwo";
import StepThird from "./StepThird";
import StepFourth from "./StepFourth";
import {
    $apis
} from "@/helper";
export default {
    components: {
        StepOne,
        StepTwo,
        StepThird,
        StepFourth
    },
    data() {
        return {
            btnLoading:false,
            activeStep: 0,
            readOnlyStatus: null,
            step2State: false
        };
    },
    computed: {
        familyReadonly() {
            return this.$store.state.base.familyReadonly;
        }
    },
    methods: {
        errdone(){
                this.btnLoading=false
            console.log( this.btnLoading);
        
        },
        back() {
            this.$router.push({
                name: 'family-day-2019'
            })
        },
        updatedFamilyList() {
            this.$refs.step2.getFamilyList();
        },
        updatedFamilyRecord() {
            this.$refs.step3.getFamilyRecord();
        },
        async validateAsync1() {
            let result = await this.$refs.step1.onSubmit();
            if (result) {
                   await this.$refs.step2.cancle();
                await this.updatedFamilyList();
                return true;
            } else {
                return false;
            }
        },
        async validateAsync2() {
            if (this.step2State) {
                if(localStorage.getItem("record-id")){
                return await this.$refs.step2.changeSubmit();
                }else{
                     let result = await this.$refs.step2.submit();
                if (result) {
                    await this.updatedFamilyRecord();
                    this.step2State = true;
                    return true;
                } else {
                    this.step2State = false;
                    return false;
                }
                }
            } else {
                let result = await this.$refs.step2.submit();
                if (result) {
                    await this.updatedFamilyRecord();
                    this.step2State = true;
                    return true;
                } else {
                    this.step2State = false;
                    return false;
                }
            }
        },
        async validateAsync3() {
            this.btnLoading=true
            return await this.$refs.step3.submitFamilyRecord();
        },
        goUp() {
            this.$router.push({
                path: "family-day-2019"
            });
        }
    },
    async beforeRouteEnter(to, from, next) {
        let resp = await $apis.user.getPage();
        let familyReadonly = resp.data["family-day-2019-readonly"];
        if (familyReadonly) {
            next({
                name: "family-day-2019"
            });
        } else {
            next();
        }
    },
    async created() {
        let resp = await $apis.family.familyList();
        this.readOnlyStatus = resp.data.readOnlyStatus;
        if (this.readOnlyStatus > 0) this.$refs['formWizard'].changeTab(0,1);
    }
};
</script>
